import { render, staticRenderFns } from "./WithdrawalOffexchange.vue?vue&type=template&id=1598f4bf&scoped=true&"
import script from "./WithdrawalOffexchange.vue?vue&type=script&lang=js&"
export * from "./WithdrawalOffexchange.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalOffexchange.vue?vue&type=style&index=0&id=1598f4bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1598f4bf",
  null
  
)

export default component.exports